import clsx from 'clsx'
import type { PropsWithChildren } from 'react'

import { FvLinkButton, type IconName } from '@fv/client-components'
import type { Workflow } from '@fv/models'

import { HasWorkflow } from '../auth/HasWorkflow'

type ModeLinkProps = {
  icon: IconName
  label: string
  isActive: boolean
  onClick: () => void
  className?: string
}

const ModeLink = ({
  icon,
  label,
  isActive,
  onClick,
  className,
}: ModeLinkProps) => {
  return (
    <FvLinkButton
      className={clsx(
        'border-fv-blue-300 b1350:px-4 b1350:py-2 b1350:mb-0 relative z-20 block rounded-lg border-2 p-4',
        {
          'after:border-fv-blue-300 b1350:after:right-1/2 b1350:after:translate-x-1/2  b1350:after:-rotate-45 b1350:after:bg-fv-blue-50 b1350:after:w-2 b1350:after:h-2 b1350:after:top-full bg-fv-beer-light after:absolute after:-right-3 after:top-2/4 after:z-10 after:h-3 after:w-3 after:-translate-y-1/2 after:translate-x-[calc(-50%_+_1px)] after:rotate-45 after:border-2 after:border-b-0 after:border-l-0 after:bg-fv-beer-light':
            isActive,
        },
        { 'bg-white': !isActive },
        className,
      )}
      icon={icon}
      onClick={onClick}
    >
      {label}
    </FvLinkButton>
  )
}

type Props = PropsWithChildren<{
  value: Workflow
  onChange: (value: Workflow) => void
  className?: string
  inline?: boolean
}>

export const WorkflowSelector = ({
  value,
  onChange,
  className,
  inline = false,
  children,
}: Props) => {
  return (
    <nav
      className={clsx(
        inline
          ? 'flex flex-row gap-3 overflow-auto'
          : 'bg-fv-blue-50 border-r py-8 px-6 flex flex-col gap-3 b1350:pt-5 b1350:pb-3 b1350:border-r-0 border-fv-gray b1350:border-b b1350:col-span-full b1350:flex b1350:flex-row overflow-auto h-full',
        className,
      )}
    >
      <HasWorkflow workflow="parcel">
        <ModeLink
          icon="box"
          label="Parcel"
          onClick={() => onChange('parcel')}
          isActive={value === 'parcel'}
          className={inline ? 'p-3' : undefined}
        />
      </HasWorkflow>
      <HasWorkflow workflow="ltl">
        <ModeLink
          icon="truck"
          label="LTL"
          onClick={() => onChange('ltl')}
          isActive={value === 'ltl'}
          className={inline ? 'p-3' : undefined}
        />
      </HasWorkflow>
      <HasWorkflow workflow="truckload">
        <ModeLink
          icon="truck-moving"
          label="Truckload"
          onClick={() => onChange('truckload')}
          isActive={value === 'truckload'}
          className={inline ? 'p-3' : undefined}
        />
      </HasWorkflow>
      {children}
    </nav>
  )
}
